import React from 'react'
import './css/contact.css';
import Navbar from './Navbar';
import Footer from './Footer';
import Section1 from './Section1';
import Iframe from 'react-iframe'
import { useState } from 'react';
export default function Contact() {
    const [user, setUser] = useState({
        name: "",
        email: "",
        mobile: "",
        subject: "",
        message: "",
    });
    let name, value;
    const getUserData = (event) => {
        name = event.target.name;
        value = event.target.value;
        setUser({ ...user, [name]: value })
    };
    const postData = async (e) => {
        e.preventDefault();
        const { name, email, mobile, subject, message } = user;
        if (name && email && mobile && subject && message) {
            const res = await fetch("https://snowcare-fcb04-default-rtdb.firebaseio.com/snowcareform.json",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name,
                    email,
                    mobile,
                    subject,
                    message,
                })
            }
        );
        if (res) {
            setUser({
                name: "",
                email: "",
                mobile: "",
                subject: "",
                message: "",
            });
            alert("data store")
        } 
        }
        else{
            alert("Fill the data")
        }
        
    };

    return (
        <>
            <Navbar />
            <main class="main">
                <Section1 sectionName={"Contact Us"} />
                <section class="section2">
                    <div className="section_container">
                        <div class="s2_first">
                            <div class="s2_first_one">
                                <h1>Contact</h1>
                                <h2>If You Have Any Question <br />
                                    Drop A Message</h2>
                            </div>
                        </div>
                        <div class="s2_second">
                            <div class="s2_container">
                                <div class="s2_second_1">
                                    <span class="material-symbols-outlined contact_icon">
                                        location_on
                                    </span>
                                    <span class="contact_content">Pirgacha, Barasat, Kolkata <br />
                                        (WB) 743 294</span>
                                </div>
                                <div class="s2_second_1">
                                    <span class="material-symbols-outlined contact_icon">
                                        call
                                    </span>
                                    <span class="contact_content">+91 6291711674 <br />
                                        +91 9330634629</span>
                                </div>
                                <div class="s2_second_1">
                                    <span class="material-symbols-outlined contact_icon">
                                        alternate_email
                                    </span>
                                    <span class="contact_content c3">snowfallrefrigeration4@gmail.com <br />
                                        info@snowfall-refrigeration.com</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section3_contact">
                    <div class="contact_section3_container">
                        <div class="left_s3">
                            <form method="POST" >
                                <div class="first_form">
                                    <input class="first_in" type="text" name="name" id="name" placeholder="Name" autoComplete='off' required onChange={getUserData} value={user.name} />
                                    <input type="tel" name="mobile" id="mobile" placeholder="Mobile No." autoComplete='off' required onChange={getUserData} value={user.mobile} />
                                </div>
                                <div class="second_form">
                                    <input type="email" name="email" id="email" placeholder="Email" autoComplete='off' required onChange={getUserData} value={user.email} />

                                </div>
                                <div class="second_form">
                                    <input type="text" name="subject" id="subject" placeholder="Subject" autoComplete='off' required onChange={getUserData} value={user.subject} />
                                </div>
                                <div class="last_form">
                                    <textarea name="message" id="textarea" rows="5"
                                     placeholder="Your Message..." value={user.message} onChange={getUserData}></textarea>
                                </div>
                                <div class="submit_btn">
                                    <button onClick={postData} type="submit">Send</button>
                                    
                                </div>
                            </form>
                        </div>
                        <div class="right_s3">
                            <Iframe url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117223.55662931709!2d85.25127540954686!3d23.343457744639824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f4e104aa5db7dd%3A0xdc09d49d6899f43e!2sRanchi%2C%20Jharkhand!5e0!3m2!1sen!2sin!4v1672773524116!5m2!1sen!2sin" width="90%" height="400px" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></Iframe>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    )
}
